import { useOtherPropertiesFieldBindings } from "@Client/@Composables/application-standalone/pages/other-properties/useOtherPropertiesFieldBindings";
import { useOtherPropertiesFieldVisibility } from "@Client/@Composables/application-standalone/pages/other-properties/useOtherPropertiesFieldVisibility";
export const otherPropertiesExistingMortgageBindingsAndVisibilities = (applicantIndex, otherPropertyIndex, existingMortgageIndex, applicantId) => {
  const {
    existingMortgageBalanceRemaining,
    existingMortgageFrequency,
    existingMortgageInterestRate,
    existingMortgageLender,
    existingMortgageLoanType,
    existingMortgageMaturityDate,
    existingMortgageMortgageType,
    existingMortgageOrigAmount,
    existingMortgagePaymentAmount,
    existingMortgagePayoff,
    existingMortgageRateType,
    existingMortgageTermType
  } = useOtherPropertiesFieldBindings({
    applicantIndex,
    otherPropertyIndex,
    existingMortgageIndex
  });
  const {
    otherPropertyExistingMortgageBalanceRemainingVisibility,
    otherPropertyExistingMortgageFrequencyVisibility,
    otherPropertyExistingMortgageInterestRateVisibility,
    otherPropertyExistingMortgageLenderVisibility,
    otherPropertyExistingMortgageLoanTypeVisibility,
    otherPropertyExistingMortgageMaturityDateVisibility,
    otherPropertyExistingMortgageMortgageTypeVisibility,
    otherPropertyExistingMortgageOrigAmountVisibility,
    otherPropertyExistingMortgagePaymentAmountVisibility,
    otherPropertyExistingMortgagePayoffVisibility,
    otherPropertyExistingMortgageRateTypeVisibility,
    otherPropertyExistingMortgageTermTypeVisibility
  } = useOtherPropertiesFieldVisibility({
    applicantIndex,
    otherPropertyIndex,
    existingMortgageIndex,
    applicantId
  });
  return {
    bindings: {
      existingMortgageBalanceRemaining,
      existingMortgageFrequency,
      existingMortgageInterestRate,
      existingMortgageLender,
      existingMortgageLoanType,
      existingMortgageMaturityDate,
      existingMortgageMortgageType,
      existingMortgageOrigAmount,
      existingMortgagePaymentAmount,
      existingMortgagePayoff,
      existingMortgageRateType,
      existingMortgageTermType
    },
    visibilities: {
      otherPropertyExistingMortgageBalanceRemainingVisibility,
      otherPropertyExistingMortgageFrequencyVisibility,
      otherPropertyExistingMortgageInterestRateVisibility,
      otherPropertyExistingMortgageLenderVisibility,
      otherPropertyExistingMortgageLoanTypeVisibility,
      otherPropertyExistingMortgageMaturityDateVisibility,
      otherPropertyExistingMortgageMortgageTypeVisibility,
      otherPropertyExistingMortgageOrigAmountVisibility,
      otherPropertyExistingMortgagePaymentAmountVisibility,
      otherPropertyExistingMortgagePayoffVisibility,
      otherPropertyExistingMortgageRateTypeVisibility,
      otherPropertyExistingMortgageTermTypeVisibility
    }
  };
};